import { Translation } from '@ps/web-shared-components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import StarsChangePassword from '@swf/components/StarsChangePassword/StarsChangePassword';
import useBeforeUnload from '@swf/core/hooks/useBeforeUnload';
import type { Dispatch } from '@swf/core/store';

import {
  TXTCLI_Before_you_can_start_playingX__ELL,
  TXTCLI_Close,
  TXTCLI_Logout,
  TXTCLI_Your_password_may_not_contain__ELL
} from './ForceChangePassword.messages.json';

type DispatchProps = ReturnType<typeof mapDispatch>;
type Props = DispatchProps;

const ForceChangePassword: React.FC<Props> = ({ logout: userLogout, close }) => {
  const beforeUnload = useBeforeUnload();
  const [passwordChanged, setPasswordChanged] = useState(false);
  const logout = useCallback(() => userLogout(), [userLogout]);

  const handlePasswordChangeSuccess = useCallback(() => {
    if (!passwordChanged) {
      setPasswordChanged(true);
    }
  }, [passwordChanged]);

  useEffect(() => {
    const subscription = beforeUnload(logout);

    if (passwordChanged) {
      subscription.unsubscribe();
    }
  }, [logout, beforeUnload, passwordChanged]);

  return (
    <>
      <div>
        <Translation {...TXTCLI_Your_password_may_not_contain__ELL} />{' '}
        <Translation {...TXTCLI_Before_you_can_start_playingX__ELL} />
      </div>
      <StarsChangePassword successCallback={handlePasswordChangeSuccess} />
      {passwordChanged ? (
        <StarsButton
          variant="secondary"
          onMouseDown={() => close('/auth/force-change-password')}
          translation={TXTCLI_Close}
        />
      ) : (
        <StarsButton variant="secondary" onMouseDown={logout} translation={TXTCLI_Logout} />
      )}
    </>
  );
};

const mapDispatch = ({ auth: { logout }, modal: { close } }: Dispatch) => ({
  logout,
  close
});

// @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
export default connect<null, DispatchProps>(null, mapDispatch)(ForceChangePassword);
